<template>
  <canvas ref="canvas"></canvas>
</template>

<script>
import Chart from 'chart.js'

export default {
  name: 'PieChart',
  props: {
    capacidad: Number,
    total: Number
  },
  mounted () {
    this.renderChart()
  },
  watch: {
    total () {
      this.renderChart()
    }
  },
  methods: {
    renderChart () {
      if (this.chart) {
        this.chart.destroy()
      }
      this.chart = new Chart(this.$refs.canvas, {
        type: 'pie',
        data: {
          labels: [
            'Total Actual',
            'Disponible'
          ],
          datasets: [{
            data: [
              this.total,
              this.capacidad - this.total
            ],
            backgroundColor: [
              '#1976D2',
              '#E0E0E0'
            ]
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            position: 'bottom'
          },
          title: {
            display: true,
            text: 'Capacidad del Fraccionamiento'
          }
        }
      })
    }
  }
}
</script>
